
/**
 * inject all(!) properties from store module
 * with getter and setter ready to be used in v-bind twoway binding
 * call with spread inside computed like ...mapTwoWay
 * @param {string[]} fieldList all the mapped fields
 * @param {object} fieldMapping optional to flatten/rename deep objects {localName:"statePath.subStatePath", ...}
 * @param {string} statePath optional but only if this.statePath in props/computed/... already exists, else it is required
 * @returns {object}
 */
export var mapTwoWay = function(fieldList = [], fieldMapping = {}, statePath) {
  let oComputed = {};
  for (let field of fieldList) {
    oComputed[field] = {
      get() {
        const path = statePath || this.statePath;
        let oReturn = this.getStateRef(path);
        if (fieldMapping[field]) {
          for (let sPath of fieldMapping[field].split(".")) {
            oReturn = oReturn[sPath];
          }
          return oReturn;
        } else {
          //ONLY for unmapped (non deep) fields, we create them in the store dynamically
          // eslint-disable-next-line no-prototype-builtins
          if (oReturn.hasOwnProperty(field)) {
            return oReturn[field];
          } else {
            this.addWatched(field, "", oReturn);
            this.updateState(field, "", path);
            return "";
          }
        }
      },
      set(value) {
        const path = statePath || this.statePath;
        if (fieldMapping[field]) {
         this.updateState(fieldMapping[field], value, path);
        } else {
          this.updateState(field, value, path);
        }
      }
    };
  }

  return oComputed;
};

export default {
  props: {
    statePath: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    stateRef() {
      let oRef = this.$store.state;
      for (let sPath of this.statePath.split(".")) {
        oRef = oRef[sPath];
      }
      return oRef;
    }
  },
  methods: {
    /**
     * mutate statePath.field = value
     * @param {string} field
     * @param {*} value
     * @param {string} statePath
     */
    updateState(field, value, statePath) {
      let oTransfer = {};
      let oLoop = oTransfer;
      statePath = statePath || this.statePath;
      let aPath = (statePath + "." + field ).split(".");
      let sField = aPath.pop();

      for (let i = 0; i < aPath.length; i++) {
        oLoop[aPath[i]] = {};
        oLoop = oLoop[aPath[i]];
      }
      oLoop[sField] = value;
      this.$store.commit("setObject", oTransfer);
    },

    /**
     * call mutation for setting 
     * a new observed field (stateRef.field = value) in the store
     * @param {*} field
     * @param {*} value
     * @param {*} stateRef
     */
    addWatched(field, value, stateRef) {
      stateRef = stateRef || this.stateRef;
      let oTransfer = {};
      oTransfer["target"] = stateRef;
      oTransfer["key"] = field;
      oTransfer["value"] = value;
      this.$store.commit("addWatched", oTransfer);
    },
    
    /**
     * get an object reference to the 
     * part of the state pointed to by val
     * @param {string} val path inside store
     * @returns 
     */
    getStateRef(val) {
      let oRef = this.$store.state;
      for (let sPath of val.split(".")) {
        oRef = oRef[sPath];
      }
      return oRef;
    }
  }
};
